import { IIndexable } from './IIndexable';

export class Phone {
  prefix: string;
  telephone: string;
  typeTelephone?: string;

  constructor(prefix: string = '', telephone: string = '', typeTelephone: string = '') {
    this.prefix = prefix;
    this.telephone = telephone;
    this.typeTelephone = typeTelephone;
  }

  toString(): string {
    if (this.prefix) return `${this.prefix}-${this.telephone}`;
    return this.telephone;
  }

  static parse(obj: IIndexable): Phone {
    return new Phone(obj.prefix, obj.telephone, obj.typeTelephone);
  }
}
